.inventoryGlobal {
	margin-right: 10px !important;
	margin-left: 10px !important;
	margin-top: 5px;
	padding-bottom: 1em;

	@media (max-width: 750px) {
		margin-right: 10px !important;
		margin-left: 10px !important;
	}

	.filter {
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		background-color: #ffffff;
		box-shadow: 5px 5px 10px #dfe1e6;
		border-right: 1px solid #d8d8d8;
		padding-right: 0px;
		padding-left: 0px;
		min-height: 82vh;
		max-height: 82vh;

		.filterTitle {
			margin-top: 15px;
			font-size: 15px;
			padding: 0px 10px;
		}

		.filterHr {
			margin-top: 5px;
			margin-bottom: 5px;
		}

		.divContent {
			height: 83%;
			overflow-y: auto;
			overflow-x: hidden;
			padding: 0px 10px;

			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}

			&::-webkit-scrollbar-track {
				background: #f1f1f1;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}

			.divForm {
				margin-top: 10px;

				.divLabel {
					margin-bottom: 4px;
					display: flex;
					align-items: center;

					.label {
						font-weight: 500;
						font-size: 14px;
					}
				}
			}
		}

		.divFooter {
			display: flex;
			justify-content: space-evenly;
			padding-top: 7px;

			.buttonClean {
				padding: 2px 15px;
				font-size: 13px;
				font-weight: 500;

				background-color: white !important;
				color: #81ba43 !important;

				&:hover {
					background-color: #5d9125 !important;
					color: white !important;
				}
			}

			.buttonApply {
				padding: 2px 15px;
				font-size: 13px;
				font-weight: 500;
			}
		}
	}

	.inventory {
		min-height: 82vh;
		max-height: 82vh;
		display: flex;
		flex-direction: column;

		width: 100%;
		box-shadow: 5px 5px 10px #dfe1e6;
		background-color: white;

		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;

		@media (max-width: 750px) {
			min-height: 78vh;
			max-height: 78vh;
		}

		.selectUnit {
			display: inline-flex;
			background-color: #fafafa;
			padding: 0.6em;
			border-radius: 10px;
			font-size: 14px;
			font-weight: 500;
			margin-right: 10px;
			cursor: pointer;
			border: none;
			width: 100%;
		}

		.header {
			flex-wrap: wrap;
			align-items: center;
			border-bottom: 0.5px solid #dee2e6;

			@media (max-width: 750px) {
				height: 20%;
			}

			.filterButton {
				display: inline-flex;
				background-color: #fafafa;
				padding: 0.7em;
				border-radius: 10px;
				font-size: 15px;
				font-weight: 500;
				margin-right: 10px;
				cursor: pointer;

				background-image: url("../../assets/images/desktop/filtro.svg");
				background-position: left;
				background-repeat: no-repeat;
				background-size: 40px 15px;

				span {
					margin-left: 27px;
				}

				&:hover {
					background-image: url("../../assets/images/desktop/filtro-white.svg");
					background-color: #7fb02f;
					color: white;
				}

				&.active {
					background-image: url("../../assets/images/desktop/filtro-white.svg");
					background-color: #7fb02f;
					color: white;
				}
			}

			.functionColBase {
				padding-right: 5px;
				padding-left: 5px;
				display: flex;
				justify-content: right;

				@media (max-width: 750px) {
					justify-content: center;
				}

				.rowOptionButton {
					width: 100%;
					justify-content: flex-end;
					flex-wrap: nowrap;

					@media (max-width: 750px) {
						flex-wrap: wrap;
						justify-content: center;
					}

					.colOptionButton {
						padding-left: 3px;
						margin-top: 7px;
						margin-bottom: 7px;
						max-width: 12%;

						@media (max-width: 1050px) {
							max-width: 14%;
						}

						@media (max-width: 750px) {
							max-width: 50%;
							padding-left: 2px;
							padding-right: 2px;
						}

						.optionButton {
							display: flex;
							align-items: center;
							background-color: #fafafa;
							border-radius: 10px;
							font-size: 15px;
							font-weight: 500;
							cursor: pointer;
							padding: 7px 10px;

							height: 100%;
							justify-content: center;

							@media (max-width: 750px) {
								margin-bottom: 5px;
								padding: 5px;
								border-radius: 5px;
							}

							span {
								margin-left: 27px;
							}

							&:hover {
								background-color: #7fb02f;
								color: white;
							}

							.icon {
								margin-right: 7px;
								margin-top: 3px;
							}

							&.showInventory {
								background-image: url("../../assets/images/desktop/inventarionegro.svg");
								background-position: left;
								background-repeat: no-repeat;
								background-size: 40px 20px;

								&:hover {
									background-image: url("../../assets/images/desktop/inventarioblanco.svg");
								}

								&.active {
									background-image: url("../../assets/images/desktop/inventarioblanco.svg");
									color: white;
									background-color: #7fb02f;
								}
							}

							&.showEmpty {
								background-image: url("../../assets/images/desktop/vacionegro.svg");
								background-position: left;
								background-repeat: no-repeat;
								background-size: 40px 20px;

								&:hover {
									background-image: url("../../assets/images/desktop/vacioblanco.svg");
								}

								&.active {
									background-image: url("../../assets/images/desktop/vacioblanco.svg");
									color: white;
									background-color: #7fb02f;
								}
							}

							&.newInventory {
								background-image: url("../../assets/images/desktop/cargarnegro.svg");
								background-position: left;
								background-repeat: no-repeat;
								background-size: 40px 20px;

								&:hover {
									background-image: url("../../assets/images/desktop/cargarblanco.svg");
								}

								&.active {
									background-image: url("../../assets/images/desktop/cargarblanco.svg");
									color: white;
									background-color: #7fb02f;
								}
							}

							&.randomInventory {
								background-image: url("../../assets/images/desktop/random.svg");
								background-position: left;
								background-repeat: no-repeat;
								background-size: 40px 20px;

								&:hover {
									background-image: url("../../assets/images/desktop/randomblanco.svg");
								}

								&.active {
									background-image: url("../../assets/images/desktop/randomblanco.svg");
									color: white;
									background-color: #7fb02f;
								}
							}

							&.exportInventory {
								background-image: url("../../assets/images/desktop/descargarnegro.svg");
								background-position: left;
								background-repeat: no-repeat;
								background-size: 40px 20px;

								&:hover {
									background-image: url("../../assets/images/desktop/descargarblanco.svg");
								}

								&.active {
									background-image: url("../../assets/images/desktop/descargarblanco.svg");
									color: white;
									background-color: #7fb02f;
								}
							}

							&.printInventory {
								background-image: url("../../assets/images/desktop/imprimirnegro.svg");
								background-position: left;
								background-repeat: no-repeat;
								background-size: 40px 20px;

								&:hover {
									background-image: url("../../assets/images/desktop/imprimirblanco.svg");
								}

								&.active {
									background-image: url("../../assets/images/desktop/imprimirblanco.svg");
									color: white;
									background-color: #7fb02f;
								}
							}

							&.pendingInventory {
								background-image: url("../../assets/images/desktop/pending.svg");
								background-position: left;
								background-repeat: no-repeat;
								background-size: 40px 20px;

								&:hover {
									background-image: url("../../assets/images/desktop/pending.svg");
								}

								&.active {
									background-image: url("../../assets/images/desktop/pending.svg");
									color: white;
									background-color: #7fb02f;
								}
							}
						}
					}
				}
			}

			.optionShow {
				display: inline-flex;
				background-color: #fafafa;
				padding: 0.7em;
				border-radius: 10px;
				font-size: 11px;
				font-weight: 500;
				margin-right: 10px;
				border: 2px solid #7fb02f;
			}

			.dates {
				padding-right: 0px;
				padding-left: 0px;

				.globalDates {
					margin-right: 0px;
					margin-left: 0px;
					display: flex;
					align-items: center;

					.buttonClean {
						padding-right: 0px;
						padding-left: 0px;
						cursor: pointer;
					}

					.colDates {
						padding-right: 0px;
						padding-left: 0px;
						font-size: 14px;

						.inputDateFrom {
							width: 100%;
							background: #fafafa;
							border: inherit;
							height: 100%;
							padding: 0.7em;
							border-bottom-left-radius: 10px;
							border-top-left-radius: 10px;
							border-right: 1px solid black;
						}

						.inputDateTo {
							width: 100%;
							background: #fafafa;
							border: inherit;
							height: 100%;
							padding: 0.7em;

							border-bottom-right-radius: 10px;
							border-top-right-radius: 10px;
						}
					}

					.icon {
						fill: #7fb02f;

						&:hover {
							fill: #5a8217;
						}
					}
				}
			}

			.unit {
				padding-right: 5px;
				padding-left: 5px;
			}

			.paginator {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				padding-right: 0px;
				padding-left: 0px;
			}

			.separator {
				width: 98%;
				margin-top: 0.2em;
				margin-bottom: 0.2em;
			}

			.headerTable {
				height: 8%;
			}
		}

		.actions {
			height: 10%;

			.actionRow {
				display: flex;
				align-items: center;

				.label {
					display: inline-flex;
					width: 7%;
					font-size: 13px;
				}

				.optionButton {
					display: inline-flex;
					background-color: #fafafa;
					padding: 0.7em;
					border-radius: 10px;
					font-size: 13px;
					font-weight: 400;
					margin-right: 10px;
					cursor: pointer;
					max-width: 15em;
					padding: 7px 10px;

					span {
						margin-left: 30px;

						div {
							display: inline-flex;
							font-weight: 700;
						}
					}

					&:hover {
						background-color: #7fb02f;
						color: white;
					}

					.icon {
						margin-right: 7px;
						margin-top: 3px;
					}

					&.editInventory {
						background-image: url("../../assets/images/desktop/editar1.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;

						&:hover {
							background-image: url("../../assets/images/desktop/editar2.svg");
						}

						&.active {
							background-image: url("../../assets/images/desktop/editar2.svg");
							color: white;
							background-color: #7fb02f;
						}
					}

					&.printEmpty {
						background-image: url("../../assets/images/desktop/imprimir1.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;

						&:hover {
							background-image: url("../../assets/images/desktop/imprimir2.svg");
						}

						&.active {
							background-image: url("../../assets/images/desktop/imprimir2.svg");
							color: white;
							background-color: #7fb02f;
						}
					}

					&.deleteInventory {
						background-image: url("../../assets/images/desktop/eliminar1.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;

						&:hover {
							background-image: url("../../assets/images/desktop/eliminar2.svg");
						}

						&.active {
							background-image: url("../../assets/images/desktop/eliminar2.svg");
							color: white;
							background-color: #7fb02f;
						}
					}
				}
			}

			.separator {
				width: 98%;
				margin-top: 0.5em;
				margin-bottom: 0.5em;
			}

			@media (max-width: 750px) {
				height: 12%;
			}
		}

		.headerTable {
			height: 8%;

			@media (max-width: 750px) {
				display: none;
			}
		}

		.table {
			height: 88%;
			overflow-y: auto;
			overflow-x: hidden;

			border-collapse: separate;
			border-spacing: 0 1em;
			display: flex;
			align-content: flex-start;
			position: relative;

			.table_desktop {
				display: inline-table;

				@media (max-width: 750px) {
					display: none;
				}
			}

			@media (max-width: 750px) {
				height: 75%;
			}

			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}

			&::-webkit-scrollbar-track {
				background: #f1f1f1;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}

			.tableContent {
				width: 99%;
				margin: auto;
				margin-bottom: 0.5em;
				font-size: 15px;
				position: relative;

				@media (max-width: 750px) {
					display: none;
				}

				tr {
					background-color: #fafafa;

					&.active {
						background-color: #c7e0a9;
					}

					&.otherActive {
						color: #bbbbbb;
					}

					td {
						border-top: inherit;
					}

					& :first-child {
						border-top-left-radius: 10px;
						border-bottom-left-radius: 10px;
					}

					& :last-child {
						border-top-right-radius: 10px;
						border-bottom-right-radius: 10px;
					}
				}
			}

			.detailDiv {
				width: 100%;
				padding-left: 1em;
				padding-right: 1em;

				@media (max-width: 750px) {
					display: none;
				}

				table {
					width: 100%;
					font-size: 15px;
					text-align: center;
					margin-bottom: 6px;

					.in_use {
						color: #f53535;
					}

					tr {
						td {
							background-color: #f2f8ec;

							.icon {
								cursor: pointer;
							}

							.floating {
								z-index: 1;
								position: absolute;
								background-color: white;
								right: 8%;
								padding-left: 1em;
								padding-right: 1em;
								border-radius: 10px;
								min-height: 17vh;
								min-width: 23vh;
								text-align: left;
								box-shadow: 5px 5px 10px #dfe1e6;
								display: none;

								&.open {
									display: block;
								}

								&.download {
									right: 4%;
								}

								h4 {
									font-size: 14px;
									margin-top: 5px;
									color: #628822;
								}

								table {
									text-align: left;
									font-size: 14px;

									tr {
										cursor: pointer;

										td {
											background-color: white;

											.icon {
												margin-right: 10px;
											}
										}
									}
								}
							}
						}

						& td:first-child {
							border-top-left-radius: 10px;
							border-bottom-left-radius: 10px;
						}

						& td:last-child {
							border-top-right-radius: 10px;
							border-bottom-right-radius: 10px;
						}

						th {
							font-size: 12px;
							font-weight: 400;
							text-align: center;
							margin: auto;
							padding-right: 0px !important;
							padding-left: 0px !important;
						}
					}
				}
			}
		}
	}
}

.printTags {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	.title {
		font-size: 20px;
		color: #96969a;
	}

	.containButton {
		display: flex;
		justify-content: flex-end;
	}

	.containButtonEnd {
		display: flex;
		justify-content: flex-start;
	}

	.button {
		border: 2px solid #5a8216;
		color: #5a8216;
		width: 60%;
		border-radius: 5px;
		padding: 8px;
	}
}

.floatNumber {
	font-size: 10px;
	position: absolute;
	top: 65%;
	padding: 1px 4px;
	border-radius: 50%;
	background: #dc3545;
	color: white;
	margin-left: 0px !important;
}

// Nueva Tabla
.table_tr {
	&.otherActive {
		color: #bbbbbb;
	}

	.table_td {
		padding-top: 5px;
		padding-bottom: 5px;
		padding-left: 0px;
		padding-right: 0px;
		border-top: 0px;

		&.first_td {
			padding-left: 5px;
			padding-right: 0px;
		}

		&.last_td {
			padding-left: 0px;
			padding-right: 5px;
		}

		.table_div {
			height: 100%;
			background-color: #fafafa;
			min-height: 4em;
			padding-top: 5px;
			padding-bottom: 5px;
			display: flex;
			align-items: center;

			.stock_number {
				padding: 8px;
				border-radius: 5px;
				cursor: pointer;

				&:hover {
					background-color: #ddd;
				}
			}

			&.active {
				background-color: #c7e0a9;
			}

			&.number_value {
				text-align: center;
				justify-content: right;
				padding-right: 20px;
			}

			&.center {
				text-align: center;
				justify-content: center;
			}

			&.first_div {
				border-top-left-radius: 5px;
				border-bottom-left-radius: 5px;
				justify-content: center;
				overflow: hidden;
			}

			&.last_div {
				border-top-right-radius: 5px;
				border-bottom-right-radius: 5px;
				justify-content: center;
			}

			&.editable {
				cursor: pointer;
			}

			&.loading {
				justify-content: center;
			}
		}
	}
}

.table_detail {
	width: 100%;
	padding-left: 1em;
	padding-right: 1em;

	.td_table {
		padding-bottom: 0px;
		padding-top: 0px;
		border-top: 0px;
		border-bottom: 0px;

		.table_item {
			width: 100%;
			font-size: 15px;
			text-align: center;
			margin-bottom: 6px;

			.in_use {
				color: #f53535;
			}

			.table_item_tr {
				.table_item_td {
					background-color: white;
					padding-top: 5px;
					padding-bottom: 5px;
					padding-left: 0px;
					padding-right: 0px;
					border-top: 0px;

					.icon {
						cursor: pointer;
					}

					.floating {
						z-index: 1;
						position: absolute;
						background-color: white;
						right: 8%;
						padding-left: 10px;
						padding-right: 10px;
						border-radius: 10px;
						min-height: 12vh;
						min-width: 24vh;
						text-align: left;
						box-shadow: 5px 5px 10px #dfe1e6;
						display: none;

						&.open {
							display: block;
							top: 75%;
						}

						&.download {
							right: 4%;
						}

						h4 {
							font-size: 14px;
							margin-top: 5px;
							color: #628822;
						}

						table {
							text-align: left;
							font-size: 14px;
							width: 100%;
							border-top: 0.5px solid #628822;

							tr {
								cursor: pointer;

								td {
									border: 0px;
									background-color: white;
									padding: 5px;

									.icon {
										margin-right: 10px;
									}
								}
							}
						}
					}

					.div_item {
						display: flex;
						align-items: center;
						height: 100%;
						background-color: #f2f8ec;
						min-height: 3.5em;
						padding-top: 5px;
						padding-bottom: 5px;
						justify-content: center;
						overflow: hidden;

						.stock_number {
							padding: 8px;
							border-radius: 5px;
							cursor: pointer;

							&:hover {
								background-color: #ddd;
							}
						}

						&.number_value {
							justify-content: right;
							padding-right: 20px;
						}

						&.in_use {
							background-color: #fdd3d3;
						}

						&.first_div {
							border-top-left-radius: 5px;
							border-bottom-left-radius: 5px;
							justify-content: center;
							align-items: center;
							display: flex;
							overflow: hidden;
						}

						&.last_div {
							border-top-right-radius: 5px;
							border-bottom-right-radius: 5px;
							justify-content: center;
							align-items: center;
							display: flex;
							position: relative;
						}
					}
				}

				& td:first-child {
					border-top-left-radius: 10px;
					border-bottom-left-radius: 10px;
				}

				& td:last-child {
					border-top-right-radius: 10px;
					border-bottom-right-radius: 10px;
				}

				.th_detail {
					font-size: 10px;
					font-weight: 400;
					text-align: center;
					margin: auto;
					padding-right: 0px !important;
					padding-left: 0px !important;
					padding-top: 5px;
					padding-bottom: 5px;
					border-top: 0px;
					border-bottom: 0px;
				}
			}
		}
	}
}

// Print
.print_option {
	display: flex;
	justify-content: space-between;

	.global_option {
		width: 48%;
		padding: 10px;
		border: 1px solid black;
		text-align: center;
		display: flex;
		justify-content: center;
		flex-direction: column;
		border-radius: 5px;
		cursor: pointer;
		font-weight: 400;
		min-height: 6em;

		background-position: left;
		background-repeat: no-repeat;
		background-size: 75px 52px;

		span {
			padding-left: 4em;
		}

		&.sale {
			background-image: url("../../assets/images/icons/Purchase/sales_black.svg");

			&:hover {
				background-image: url("../../assets/images/icons/Purchase/sales.svg");
			}
		}

		&.delivery {
			background-image: url("../../assets/images/icons/Purchase/delivery_black.svg");

			&:hover {
				background-image: url("../../assets/images/icons/Purchase/delivery.svg");
			}
		}

		&:hover {
			color: white;
			background-color: #7fb02f;
			border: initial;
		}

		.icon {
			width: 4em;
			height: 4em;
		}
	}
}

// Actions
.floating {
	z-index: 1;
	position: absolute;
	background-color: white;
	right: 50%;
	padding-left: 10px;
	padding-right: 10px;
	border-radius: 5px;
	min-width: 30vh;
	text-align: left;
	box-shadow: 5px 5px 6px #7b7b7b;
	top: 70%;

	&.open {
		display: block;
		top: 75%;
	}

	&.download {
		right: 4%;
	}

	h4 {
		font-size: 14px;
		margin-top: 5px;
		color: #628822;
	}

	table {
		text-align: left;
		font-size: 14px;
		width: 100%;
		border-top: 0.5px solid #628822;
		margin-bottom: 5px;

		tr {
			cursor: pointer;

			td {
				border: 0px;
				background-color: white;
				padding: 5px;

				.icon {
					margin-right: 10px;
				}
			}
		}

		.tdStock {
			background-image: url("../../assets/images/desktop/alert-critical.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdResume {
			background-image: url("../../assets/images/desktop/movements.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
		}

		.tdSpan {
			padding-left: 33px;
		}
	}
}
